import { Empty, Skeleton } from 'antd';
import { Column } from '@ant-design/charts';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { withTranslation } from 'react-i18next';
import AccountServices from '../../../../services/account.services';
import _ from 'lodash';

function RaoChart({ globalSettings, selectedNode, t, mainColor }) {
  const [raoData, setRaoData] = useState([]);
  const getRaoCountData = (accountServices, role) => {
    return accountServices
      .listAccounts(
        selectedNode.nodeId,
        { ...(role ? { roles: role } : { login: '' }) },
        { login: 'ASC' },
        1,
        false,
        200
      )
      .then(
        (response) => {
          if (response?.data) {
            if (accountServices.checkError(response)) {
              return 0;
            } else {
              const result = accountServices.getResult(response);

              return result.accountsRows || 0;
            }
          }
        },
        (error) => {
          if (axios.isCancel(error)) {
            //this.logFirer.fireLog('LOG', error);
          } else {
            return 0;
          }
        }
      );
  };
  const getRaoData = (accountServices) => {
    setIsRaoDataLoaded(false);

    Promise.all([
      getRaoCountData(accountServices, 'master_rao'),
      getRaoCountData(accountServices, 'rao'),
      getRaoCountData(accountServices, 'ir'),
    ])
      .then((response) => {
        if (response) {
          setRaoData([
            {
              type: t('App.AssignableRole.Role.master_rao'),
              value: response[0],
            },
            { type: t('App.AssignableRole.Role.rao'), value: response[1] },
            { type: t('App.AssignableRole.Role.ir'), value: response[2] },
          ]);
          setIsRaoDataLoaded(true);
        }
      })
      .catch((_) => {
        setIsRaoDataLoaded(true);
      });
  };

  const raoChartConfig = {
    data: raoData,
    xField: 'type',
    yField: 'value',
    seriesField: 'type',
    color: [mainColor, '#01CFCB', '#525566'],
    label: {
      position: 'middle',
      style: {
        fill: '#FFFFFF',
        opacity: 0.6,
      },
    },
  };
  const [isRaoDataLoaded, setIsRaoDataLoaded] = useState(false);

  useEffect(() => {
    let env;

    if (_.isString(process.env.REACT_APP_ENV)) {
      env = process.env.REACT_APP_ENV;
    } else {
      env = globalSettings.DefaultEnvironment;
    }

    const accountServices = new AccountServices(
      globalSettings.Environment[env]
    );

    getRaoData(accountServices);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNode]);

  const checkDataEmpty = () => raoData.filter((data) => data.value > 0);

  return isRaoDataLoaded ? (
    checkDataEmpty().length ? (
      <Column {...raoChartConfig} />
    ) : (
      <Empty />
    )
  ) : (
    <Skeleton active />
  );
}

export default withTranslation()(RaoChart);
